
(() => {
  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(cents / 100);
    } catch {
      return '₱' + (cents / 100).toFixed(2);
    }
  };

  const qs = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => [...c.querySelectorAll(s)];

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('Unable to load cart.');
    return res.json();
  }

  async function addToCart(form) {
    const data = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    });
    if (!res.ok) {
      let msg = 'Unable to add this item.';
      try {
        const err = await res.json();
        msg = err.description || msg;
      } catch {}
      throw new Error(msg);
    }
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error('Unable to update cart.');
    return res.json();
  }

  function updateCartCount(count) {
    qsa('[data-cart-count], .cart-count, .header__cart-count').forEach(el => {
      el.textContent = count;
      el.hidden = false;
    });
  }

  function renderDrawer(cart) {
    const drawer = qs('#SalveoCartDrawer');
    if (!drawer) return;
    const items = qs('[data-cart-items]', drawer);
    const subtotal = qs('[data-cart-subtotal]', drawer);
    const empty = qs('[data-cart-empty]', drawer);

    updateCartCount(cart.item_count);
    subtotal.textContent = money(cart.total_price);

    if (!cart.items.length) {
      items.innerHTML = '';
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    items.innerHTML = cart.items.map(item => `
      <article class="sfc-item" data-key="${item.key}">
        <a href="${item.url}" class="sfc-item__image">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g,'&quot;')}" loading="lazy">` : ''}
        </a>
        <div class="sfc-item__content">
          <a href="${item.url}" class="sfc-item__title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="sfc-item__variant">${item.variant_title}</div>` : ''}
          <div class="sfc-item__price">${money(item.final_line_price)}</div>
          <div class="sfc-qty">
            <button type="button" data-qty-minus aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-qty-plus aria-label="Increase quantity">+</button>
            <button type="button" class="sfc-remove" data-remove>Remove</button>
          </div>
        </div>
      </article>
    `).join('');
  }

  async function refreshDrawer(open = false) {
    const cart = await getCart();
    renderDrawer(cart);
    if (open) openDrawer();
  }

  function openDrawer() {
    const drawer = qs('#SalveoCartDrawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sfc-lock');
  }

  function closeDrawer() {
    const drawer = qs('#SalveoCartDrawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sfc-lock');
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart-form], form[action*="/cart/add"]');
    if (!form || form.dataset.noAjax === 'true') return;

    const submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') return;

    e.preventDefault();
    const btn = submitter || qs('[type="submit"]', form);
    const original = btn ? btn.innerHTML : '';
    try {
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = 'ADDING…';
      }
      await addToCart(form);
      await refreshDrawer(true);
      if (btn) btn.innerHTML = 'ADDED ✓';
      setTimeout(() => { if (btn) btn.innerHTML = original; }, 1200);
    } catch (err) {
      alert(err.message);
      if (btn) btn.innerHTML = original;
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-cart-drawer-open]')) {
      e.preventDefault();
      await refreshDrawer(true);
      return;
    }
    if (e.target.closest('[data-cart-drawer-close], .sfc-overlay')) {
      closeDrawer();
      return;
    }

    const item = e.target.closest('.sfc-item');
    if (!item) return;
    const key = item.dataset.key;
    const qty = parseInt(qs('.sfc-qty span', item)?.textContent || '1', 10);

    try {
      if (e.target.closest('[data-qty-minus]')) {
        renderDrawer(await changeLine(key, Math.max(0, qty - 1)));
      } else if (e.target.closest('[data-qty-plus]')) {
        renderDrawer(await changeLine(key, qty + 1));
      } else if (e.target.closest('[data-remove]')) {
        renderDrawer(await changeLine(key, 0));
      }
    } catch (err) {
      alert(err.message);
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('DOMContentLoaded', () => {
    refreshDrawer(false).catch(() => {});
  });
})();
